import { Component, OnInit, Inject, ChangeDetectorRef, NgZone } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Pipe, PipeTransform } from '@angular/core';

import { __values } from 'tslib';
import { AngularFireFunctions } from '@angular/fire/functions';
import { AngularFirestore } from '@angular/fire/firestore';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-reservation-popup',
  templateUrl: './reservation-popup.component.html',
  styleUrls: ['./reservation-popup.component.scss']
})
export class ReservationPopupComponent implements OnInit {

  hours = []
  MAX_SEATS = 31;
  hoursMapped = [];
  isTodaySelected = true;
  beginHour: any;
  beginHourFinal: any;
  endHour: any;
  endHourFinal: any;
  selectedHour: any;
  reservationDate: any;
  halfHourSegmentsSelected: any;
  isReservationOk = true;
  showMessage = false;
  isLoading = false;
  constructor(public dialogRef: MatDialogRef<ReservationPopupComponent>, private changeDetectorRef: ChangeDetectorRef, public zone: NgZone, private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any, private func: AngularFireFunctions, private fs: AngularFirestore) {
    this.filterReservedByDate(true);
  }
  selectHour(hour, halfNum) {
    if ((halfNum == 1 && hour.firstHalf.clickable) || (halfNum == 2 && hour.secondHalf.clickable)) {
      if (this.beginHour == undefined) {
        this.beginHour = hour;
        this.colorBeetween();
        if (halfNum == 1) {
          hour.firstHalf.selected = true;
          hour.firstHalf.icon = "arrow_right";
        } else {
          hour.secondHalf.selected = true;
          hour.secondHalf.icon = "arrow_right";
        }
      } else {
        this.endHour = hour;
        if (halfNum == 1) {
          hour.firstHalf.selected = true;
          hour.firstHalf.icon = "arrow_left";

        } else {
          hour.secondHalf.selected = true;
          hour.secondHalf.icon = "arrow_left";
        }
        if (this.beginHour == this.endHour) {
          if (this.beginHour.firstHalf.selected && !this.endHour.secondHalf.selected) {
            hour.firstHalf.icon = false;
            hour.firstHalf.bothIcons = true;
          } else if (!this.beginHour.firstHalf.selected && this.endHour.secondHalf.selected) {
            hour.secondHalf.icon = false;
            hour.secondHalf.bothIcons = true;
          } else if (this.beginHour.firstHalf.select && this.endHour.secondHalf.selected) {
            hour.secondHalf.icon = false;
            hour.secondHalf.bothIcons = true;
          }
        }
        this.beginHourFinal = this.beginHour.visual_upper + ":"
          + ((this.beginHour.secondHalf.selected) ? "30" : "00")
        this.endHourFinal = (!this.endHour.secondHalf.selected) ? this.addZero(parseInt(this.endHour.visual_upper)) : this.addZero((parseInt(this.endHour.visual_upper) + 1))
        this.endHourFinal += ":" + ((this.endHour.secondHalf.selected) ? "00" : "30")
        if (this.beginHour == this.endHour) {
          if (this.beginHour.firstHalf.selected && this.endHour.secondHalf.selected) {
            this.beginHourFinal = this.beginHour.visual_upper + ":00";
            this.endHourFinal = this.addZero((parseInt(this.endHour.visual_upper) + 1)) + ":00"
          } else if (this.beginHour.secondHalf.selected) {
            this.beginHourFinal = this.beginHour.visual_upper + ":30";
            this.endHourFinal = this.addZero((parseInt(this.endHour.visual_upper) + 1)) + ":00"
          } else {
            this.beginHourFinal = this.beginHour.visual_upper + ":00";
            this.endHourFinal = this.addZero(parseInt(this.endHour.visual_upper)) + ":30"
          }
        }
        var isRangeOk = true;
        var indexBegin = this.hoursMapped.indexOf(this.beginHour)
        var indexEnd = this.hoursMapped.indexOf(this.endHour)
        if (indexBegin != indexEnd)
          for (var i = indexBegin; i <= indexEnd; i++) {
            if (!this.hoursMapped[i].firstHalf.clickable || !this.hoursMapped[i].secondHalf.clickable)
              this.isReservationOk = false
          }
        if (this.isReservationOk) {
          this.colorBeetween();
          this.calculateReserved();
        }
        this.endHour = undefined;
        this.beginHour = undefined;
      }
    }
  }
  calculateReserved() {
    var counter = 0;
    this.hoursMapped.forEach(function (v, i) {
      if (v.firstHalf.selected) counter++
      if (v.secondHalf.selected) counter++
    })
    var hours = Math.floor(counter * 30 / 60);
    var minutes = counter * 30 % 60;
    this.halfHourSegmentsSelected = hours + "h" + minutes + "m";
  }
  cleanWholeTable() {
    this.hoursMapped.forEach(function (v, i) {
      v.firstHalf.bothIcons = false;
      v.secondHalf.bothIcons = false;
      v.firstHalf.icon = false;
      v.secondHalf.icon = false;
      v.firstHalf.selected = false;
      v.secondHalf.selected = false;
    })
  }
  filterTable(newDay?) {
    this.isTodaySelected = !newDay;
    this.cleanWholeTable();
    var date = new Date();
    if (!newDay) {
      date = new Date();
      // date.setHours(15,12,0,0)
      var filterReservedByDate = false;
    } else {
      var tomorrow = new Date();
      tomorrow.setDate(date.getDate() + 1);
      date = tomorrow;
      date.setHours(10, 0, 0);
      filterReservedByDate = true;
    }
    this.reservationDate = this.addZero(date.getDate()) + "." + this.addZero((date.getMonth() + 1)) + "." + this.addZero(date.getFullYear());
    var roundedTimeString = { visual: "", selected: false, clickable: true }

    roundedTimeString.visual = this.addZero(date.getHours()) + ":00";
    console.log(roundedTimeString)
    let beginIndex = this.hoursMapped.map(function (e) { return e.visual_upper + ":" + e.visual_lower; }).indexOf(roundedTimeString.visual);
    console.log(this.hoursMapped.map(function (e) { return e.visual_upper + ":" + e.visual_lower; }))
    beginIndex = (beginIndex === -1) ? -1 : beginIndex;
    for (let i = 0; i < this.hoursMapped.length; i++) {
      if (this.hoursMapped[i].firstHalf.clickable) {
        if (i < beginIndex) this.hoursMapped[i].firstHalf.clickable = false;
        else if (i == beginIndex)
          if (date.getMinutes() > 0)
            this.hoursMapped[i].firstHalf.clickable = false;
      }
      if (this.hoursMapped[i].secondHalf.clickable) {
        if (i < beginIndex) this.hoursMapped[i].secondHalf.clickable = false;
        else if (i == beginIndex)
          if (date.getMinutes() > 30)
            this.hoursMapped[i].secondHalf.clickable = false;
      }
    }
  }
  addZero(time) {
    if (time < 10) return "0" + time;
    else return time + "";
  }
  mouseEnter(hour, halfNum) {
    if (this.beginHour && !this.endHour) {
      this.selectedHour = hour;
      //this.colorBeetween();
    }

  }

  colorBeetween() {
    let beginIndex = this.hoursMapped.indexOf(this.beginHour);
    let endIndex;
    if (!this.endHour && !this.selectedHour) {
      endIndex = this.hoursMapped.indexOf(this.selectedHour);
    } else {
      endIndex = this.hoursMapped.indexOf(this.endHour);
    }
    if (!this.endHour && !this.selectedHour) endIndex = -1
    for (let i = 0; i < this.hoursMapped.length; i++) {
      if (i < beginIndex || i > endIndex) {
        this.hoursMapped[i].firstHalf.selected = false;
        this.hoursMapped[i].secondHalf.selected = false;
        this.hoursMapped[i].firstHalf.icon = false;
        this.hoursMapped[i].secondHalf.icon = false;
        this.hoursMapped[i].firstHalf.bothIcons = false;
        this.hoursMapped[i].secondHalf.bothIcons = false;
      } else if (endIndex == beginIndex) {

      } else if (i == beginIndex) {
        if (this.hoursMapped[i].secondHalf.selected) {

          this.hoursMapped[i].firstHalf.selected = false;
          this.hoursMapped[i].firstHalf.icon = false;
        }
        this.hoursMapped[i].secondHalf.selected = true;
      } else if (i == endIndex) {
        if (this.hoursMapped[i].firstHalf.selected) {
          this.hoursMapped[i].secondHalf.selected = false;
          this.hoursMapped[i].secondHalf.icon = false;
          this.hoursMapped[i].firstHalf.bothIcons = false;
          this.hoursMapped[i].secondHalf.bothIcons = false;
        }
        this.hoursMapped[i].firstHalf.selected = true;
      } else {
        this.hoursMapped[i].firstHalf.selected = true
        this.hoursMapped[i].secondHalf.selected = true
        this.hoursMapped[i].firstHalf.icon = false;
        this.hoursMapped[i].secondHalf.icon = false;
      }

    }
  }

  onNoClick(): void {
    this.dialogRef.close();

  }

  onOkClick(): void {
    this.isLoading = true;
    this.func.httpsCallable('makeReservation')({
      from: `${this.beginHourFinal}`,
      to: `${this.endHourFinal}`,
      today: this.isTodaySelected
    }).subscribe(data => {
      if (data.status === 200) {
        this.showMessage = true;
        console.log(data);
        // this.dialogRef.close({
        //   isOk: (this.isReservationOk) ? true : false,
        // });
      } else {
        this.openSnackBar("Nepravilna rezervacija.", "Ok")
      }
    }, err => {
      console.log(err)
      this.openSnackBar("Greška pri rezervaciji.", "Ok")
    }, () => {
      this.zone.run(() => {
        this.isLoading = false;
        this.changeDetectorRef.markForCheck();
      })
    })

  }
  filterReservedByDate(tommorow) {
    var date = new Date();
    date.setHours(date.getHours()+2)
    date.setUTCHours(0, 0, 0, 0)
    if (tommorow) {
      date.setDate(date.getDate() + 1);
    }
    this.fs.doc(`reservations/${date.getTime()}`).get().subscribe(reservations => {
      const allReservations = reservations.data();
      console.log(allReservations, date.getTime())
      this.hours = Object.entries(allReservations)
        .map((r:any) => {
          return {
            displayTime: `${this.addZero(parseInt(r[0]))}:00`,
            firstHalf: {
              numOfReservations: r[1].firstHalf.length
            },
            secondHalf: {
              numOfReservations: r[1].secondHalf.length
            },
          }
        })
      this.hoursMapped = this.hours.map((x) => {
        return {
          visual_upper: x.displayTime.split(":")[0],
          visual_lower: x.displayTime.split(":")[1],
          firstHalf: { selected: false, clickable: !(x.firstHalf.numOfReservations > this.MAX_SEATS), icon: false, bothIcons: false, reservationCount: x.firstHalf.numOfReservations },
          secondHalf: { selected: false, clickable: !(x.secondHalf.numOfReservations > this.MAX_SEATS), icon: false, bothIcons: false, reservationCount: x.secondHalf.numOfReservations }
        }
      });
      this.filterTable(tommorow)
    })
  }
  ngOnInit() {


  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
      verticalPosition:'top'
    });
  }

}

